var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChartParams } from "../../views/chart/chart.component";
import { TranslateService } from "../../translate";
import { EventsService } from "../../lib/EventsService";
import { ActivatedRoute } from "@angular/router";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { HelperService } from "../../lib/helper.service";
import { ModalService } from "../../views/modal/base_modal.component";
import { BaseComponent } from "../../views/base.component";
import { BillingService2 } from "../billing.service";
var DisableRecurrentComponent = /** @class */ (function (_super) {
    __extends(DisableRecurrentComponent, _super);
    function DisableRecurrentComponent(translate, eventsService, activatedRoute, filter, service2, modalService, helper) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.translate = translate;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.filter = filter;
        _this.service2 = service2;
        _this.modalService = modalService;
        _this.helper = helper;
        _this.disableRecurrentChart = new ChartParams();
        _this.disableRecurrentChart2 = new ChartParams();
        _this.disableRecurrentDetailChart = new ChartParams();
        _this.addFilterParams = {
            userType: 'user',
            isBilling: true,
            dateFilters: ['dateTime', 'dateCreated', 'datePaid', 'dateSiteCreated', 'datePublished'],
            dateType: 'dateTime'
        };
        var me = _this;
        me.disableRecurrentChart.setOptions({
            title: me.translate.__A('disable_recurrent.manual'),
            names: {
                count: 'Кол-во отписок'
            },
        });
        me.disableRecurrentChart2.setOptions({
            title: me.translate.__A('disable_recurrent.recurrent'),
            names: {
                count: 'Кол-во отписок'
            },
        });
        me.disableRecurrentDetailChart.setOptions({
            title: me.translate.__A('disable_recurrent.detail'),
            axis: {
                y: {
                    min: 1,
                    ticks: 5,
                    label: {
                        text: 'Сайты',
                        position: 'outer-middle'
                    }
                }
            },
            names: {
                disableBeforePaid: me.translate.__A('disable_recurrent.disableBeforePaid'),
                disableAfterPaid: me.translate.__A('disable_recurrent.disableAfterPaid'),
                disableOther: me.translate.__A('disable_recurrent.disableOther'),
            },
        });
        return _this;
    }
    DisableRecurrentComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        return [4 /*yield*/, me.getChart()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DisableRecurrentComponent.prototype.getChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp, charts, charts2, charts4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        fp = me.filter.filterParams;
                        me.disableRecurrentChart.showLoader();
                        return [4 /*yield*/, me.service2.disableRecurrent.chart(fp).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        me.disableRecurrentChart.data = charts;
                        me.disableRecurrentChart.hideLoader();
                        me.disableRecurrentChart2.showLoader();
                        return [4 /*yield*/, me.service2.disableRecurrent.get(fp, 'charts2').toPromise()];
                    case 2:
                        charts2 = (_a.sent()).charts;
                        me.disableRecurrentChart2.data = charts2;
                        me.disableRecurrentChart2.hideLoader();
                        me.disableRecurrentDetailChart.showLoader();
                        return [4 /*yield*/, me.service2.disableRecurrent.get(me.filter.filterParams, 'detail_chart').toPromise()];
                    case 3:
                        charts4 = (_a.sent()).charts;
                        me.disableRecurrentDetailChart.data = charts4;
                        me.disableRecurrentDetailChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DisableRecurrentComponent;
}(BaseComponent));
export { DisableRecurrentComponent };
